import { render, staticRenderFns } from "./FlavorConfig.vue?vue&type=template&id=54d82f90&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FlavorConfig.vue?vue&type=script&lang=js&"
export * from "./FlavorConfig.vue?vue&type=script&lang=js&"
import style0 from "./FlavorConfig.vue?vue&type=style&index=0&id=54d82f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d82f90",
  null
  
)

export default component.exports